module.exports = __webpack_public_path__ + "img/1513808590.0f017ed0.jpg";